// extracted by mini-css-extract-plugin
module.exports =  {"sliceBackground":"sliceBackground__80JRy","text":"text__dP7dl","textValue":"textValue__smFzS","verticalLine":"verticalLine__LWTkJ"};